import React from "react";
import { InputMask, InputMaskChangeEvent } from "primereact/inputmask";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";

interface CustomInputMaskProps {
  value: string;
  setValue: (value: string) => void;
  onBlur?: () => void;
  mask?: string;
  unmask?: boolean;
  placeholder?: string;
  icon: React.ReactNode;
  iconPosition?: "left" | "right";
  invalid?: boolean;
}

const CustomInputMask: React.FC<CustomInputMaskProps> = ({
  value,
  setValue,
  onBlur,
  mask,
  unmask = false,
  placeholder,
  icon,
  iconPosition = "left",
  invalid = false,
}) => {
  const handleChange = (e: InputMaskChangeEvent) => {
    setValue(e.value ?? "");
  };

  return (
    <IconField iconPosition={iconPosition}>
      <InputIcon>{icon}</InputIcon>
      <InputMask
        value={value}
        onChange={handleChange}
        onBlur={onBlur}
        mask={mask}
        unmask={unmask}
        placeholder={placeholder}
        invalid={invalid}
        className="w-full"
      />
    </IconField>
  );
};

export default CustomInputMask;
